<script setup lang="ts">
import RcPreloader from "@signup/components_vue3/RcPreloader.vue";

defineOptions({ inheritAttrs: false });
</script>

<template>
  <RcPreloader />
  <slot />
</template>
